import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';
import type { TcValidation } from '@/store/types.ts';

export function ExpiryDateField({ tileId, validation }: { tileId: string; validation?: TcValidation[] }): ReactElement {
  const { expiryDate, expiryDateTenor } = useFlexiForwardSelector((flexiForward) => ({
    expiryDate: flexiForward.properties.expiryDate,
    expiryDateTenor: flexiForward.properties.expiryDateTenor,
  }));

  const handleExpiryDateChanged = useFlexiForwardPropertyChangedHandler<string>(
    tileId,
    'Expiry date change',
    (dateStringOrTenor) => ({ expiryDate: dateStringOrTenor }),
  );

  return (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.expiryDate.label">
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          date={expiryDate ?? ''}
          tenor={expiryDateTenor}
          onChange={handleExpiryDateChanged}
          data-e2e="expiry-date"
        />
      </TradeCaptureValidationWrapper>
    </FlexiForwardFormField>
  );
}
